/**
 * フレンド機能のAPIクライアントサービス
 */

import type { Friend, FriendOnlineStatusListResponse, FriendRequest } from '../../types/friend'
import { AuthService } from '../auth/AuthService'

/**
 * フレンド一覧レスポンス
 */
interface FriendsResponse {
  friends: Friend[]
  totalCount: number
}

/**
 * フレンドリクエスト一覧レスポンス
 */
interface FriendRequestsResponse {
  requests: FriendRequest[]
  totalCount: number
}

/**
 * フレンド一覧を取得
 */
export async function getFriends(): Promise<FriendsResponse> {
  return AuthService.request<FriendsResponse>('/api/friends', {
    method: 'GET',
  })
}

/**
 * 受信したフレンドリクエスト一覧を取得
 */
export async function getFriendRequests(): Promise<FriendRequestsResponse> {
  return AuthService.request<FriendRequestsResponse>('/api/friends/requests', {
    method: 'GET',
  })
}

/**
 * フレンド申請を送信
 * @param addresseeId 申請先のユーザーID
 */
export async function sendFriendRequest(addresseeId: string): Promise<{ message: string }> {
  return AuthService.request<{ message: string }>('/api/friends/request', {
    method: 'POST',
    body: JSON.stringify({ addresseeId }),
  })
}

/**
 * フレンドリクエストを承認
 * @param requestId リクエストID
 */
export async function acceptFriendRequest(requestId: string): Promise<{ message: string }> {
  return AuthService.request<{ message: string }>(`/api/friends/accept/${requestId}`, {
    method: 'POST',
  })
}

/**
 * フレンドリクエストを拒否
 * @param requestId リクエストID
 */
export async function rejectFriendRequest(requestId: string): Promise<{ message: string }> {
  return AuthService.request<{ message: string }>(`/api/friends/reject/${requestId}`, {
    method: 'POST',
  })
}

/**
 * フレンドを削除
 * @param friendshipId フレンドシップID
 */
export async function removeFriend(friendshipId: string): Promise<{ message: string }> {
  return AuthService.request<{ message: string }>(`/api/friends/${friendshipId}`, {
    method: 'DELETE',
  })
}

/**
 * フレンドのオンライン状態一覧を取得
 */
export async function getFriendsOnlineStatus(): Promise<FriendOnlineStatusListResponse> {
  return AuthService.request<FriendOnlineStatusListResponse>('/api/friends/online-status', {
    method: 'GET',
  })
}
